module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTc2Ny41IDk5NCAyMDYgNTE5LjQgNzY3LjUgNDQuOCA3OTcuMiA4MCAyNzcuMyA1MTkuNCA3OTcuMiA5NTguOFoiIHAtaWQ9IjEwNTAiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/toleft.svg
// module id = 92wW
// module chunks = 73